import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import UserInfo from "../TestPage/UserInfo";
import Back from "../../assets/assets/back.svg";
import { getUserStatus } from "../../redux/Actions/GetDocsActions";
import { useHistory } from "react-router-dom";
import Doc from "../../assets/assets/docpos.svg";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { getAllApplications } from "../../redux/Actions/PosActions";
import Spinner from "react-spinner-material";
import Storage from "../../utils/storage";
import moment from "moment";
import UserModal from "../../components/EmailModal/UserModal";
import { PropTypes } from "prop-types";

export const AllPosApplications = (props) => {
  const history = useHistory();
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let userType = user && user.type;

  const { getStatus, isGetting, getAllApplications, applications } = props;

  useEffect(
    () => {
      getStatus();
      getAllApplications();
    },
    // eslint-disable-next-line
    [getStatus, getAllApplications]
  );

  const [state, setState] = useState({
    showCertModal: false,
    certModalIndex: "",
  });

  const viewCert = (index) => {
    setState({
      ...state,
      showCertModal: true,
      certModalIndex: index,
    });
  };

  const hideCert = () => {
    setState({
      ...state,
      showCertModal: false,
    });
  };
  const goBack = () => {
    history.go(-1);
  };

  const goToDeviceRenew = (id) => {
    history.push({
      pathname: "/device/renewal/details",
      state: {
        id: id,
      },
    });
  };

  const goToAppRenew = (id) => {
    history.push({
      pathname: "/application/renewal/details",
      state: {
        id: id,
      },
    });
  };

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <div className="container-body2">
        <UserInfo />
      </div>

      <div className="container-body3">
        <div className="dashboard-main">
          <div className="dashboard-main-header-title2">
            <span>All Applications</span>
            <p data-testid="goBack" onClick={() => goBack()}>
              <img src={Back} alt="back" /> Back
            </p>
          </div>

          {isGetting ? (
            <div className="center-spinner">
              <Spinner
                size={120}
                color={"#047558"}
                spinnerwidth={5}
                visible={true}
              />
            </div>
          ) : applications && applications.length === 0 ? (
            <div className="single-application-empty">
              <span>No Certified Applications</span>
            </div>
          ) : (
            applications &&
            applications.map((item, index) => (
              <div className="single-application" key={index}>
                <div className="single-application-header">
                  <p>
                    {item.company.name} Pos Certification {index + 1}
                  </p>
                  <h2>
                    <span>Date Issued:</span>
                    {moment(item.start_date).format("LL")}
                  </h2>
                </div>

                <div className="single-application-mid">
                  <div className="single-application-mid-left">
                    <h2>
                      Your POS{" "}
                      {item.application_type === "pos_device_certification"
                        ? "Device"
                        : "Application"}{" "}
                      Certification available for use
                    </h2>

                    <div className="progress-bar">
                      <CircularProgressbarWithChildren
                        value={item.cert_days_left}
                        strokeWidth={4}
                        styles={buildStyles({
                          rotation: 0.25,
                          strokeLinecap: "butt",
                          textSize: "14px",
                          pathTransitionDuration: 0.5,
                          pathColor: `${
                            item.cert_days_left <= 10 ? "red" : "lightgreen"
                          }`,
                          textColor: "#808080",
                          trailColor: "#d6d6d6",
                          backgroundColor: "#3e98c7",
                        })}
                      >
                        <div className="text-div">
                          <div className="text-bar1">{item.cert_days_left}</div>
                          <div className="text-bar2">Days Left</div>
                        </div>
                      </CircularProgressbarWithChildren>
                    </div>
                  </div>

                  <div className="single-application-mid-left">
                    {userType !== "staff" && (
                      <div>
                        {item.application_type ===
                        "pos_device_certification" ? (
                          <button
                            data-testid="goToDeviceRenew"
                            className="button1"
                            onClick={() => goToDeviceRenew(item.id)}
                          >
                            Renew
                          </button>
                        ) : (
                          <button
                            data-testid="goToAppRenew"
                            className="button1"
                            onClick={() => goToAppRenew(item.id)}
                          >
                            Renew
                          </button>
                        )}
                      </div>
                    )}

                    <button
                      data-testid="viewCert-2"
                      className="button2-pos"
                      disabled={item.certificate_terms_and_agreement !== true}
                      onClick={() => viewCert(index)}
                    >
                      <img src={Doc} alt="doc-icon" />
                      VIEW CERTIFICATION
                    </button>

                    {index === state.certModalIndex && (
                      <UserModal
                        open={state.showCertModal}
                        close={hideCert}
                        height={"739"}
                        width={"1000"}
                      >
                        <div style={{ padding: "20px" }}>
                          <span
                            data-testid="hideCert"
                            className="iframe-back2"
                            onClick={() => hideCert()}
                          >
                            X
                          </span>
                          <embed
                            src={item.certificate_url}
                            type="application/pdf"
                            width="100%"
                            height="1000"
                            title="POS Certificate"
                            name="Nibss Certificate"
                          ></embed>
                        </div>
                      </UserModal>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getStatus: () => dispatch(getUserStatus()),
  getAllApplications: () => dispatch(getAllApplications()),
});

const mapStateToProps = (state) => {
  return {
    isGetting: state.docs.isGetting || state.pos.isGettingApps,
    status: state.docs.status,
    getStatusSuccess: state.docs.getStatusSuccess,
    applications: state.pos.applications,
  };
};

AllPosApplications.propTypes = {
  getStatus: PropTypes.func,
  isGetting: PropTypes.bool,
  getAllApplications: PropTypes.func,
  applications: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllPosApplications);
